import { render, staticRenderFns } from "./FormMessage.vue?vue&type=template&id=6cc9133c&"
import script from "./FormMessage.vue?vue&type=script&lang=js&"
export * from "./FormMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports